import React from "react";
import styles from "./CreditFilterSidebar.module.css";
import { Checkbox, Collapse } from "antd";
import DatePicker from "react-datepicker2";
import { types_list } from "../Credit";

// icons
import { ReactComponent as CancelIcon } from "./../../../../../assets/svg/second-cancel.svg";
import { ReactComponent as BottomArrowIcon } from "./../../../../../assets/svg/bottom-arrow.svg";
import Button from "../../../../components/ui/Button";

const CreditFilterSidebar = (props) => {
  const {
    type,
    set_type,
    price_from,
    set_price_from,
    price_to,
    set_price_to,
    date_from,
    set_date_from,
    date_to,
    set_date_to,
    sidebar_open,
    set_sidebar_open,
    submit_filter,
  } = props;

  const checkbox_change = (value) => {
    if (value !== type) {
      set_type(value);
    } else {
      set_type(null);
    }
  };

  const on_clear_filter = () => {
    set_type(1);
    set_price_from("");
    set_price_to("");
    set_date_from(null);
    set_date_to(null);
    set_sidebar_open(false);
    submit_filter(false, true);
  };

  return (
    <div className={styles.SidebarContainer}>
      <div
        onClick={() => set_sidebar_open(false)}
        className={`${styles.Backdrop} ${sidebar_open ? styles.Active : ""}`}
      />
      {/* sidebar */}
      <div className={`${styles.Sidebar} ${sidebar_open ? styles.Active : ""}`}>
        {/* close icon */}
        <div
          onClick={() => set_sidebar_open(false)}
          className={styles.CancelIconContainer}
        >
          <CancelIcon className={styles.CancelIcon} />
        </div>
        <div className={styles.SidebarFiltersContainer}>
          {/* type collapse */}
          {/* <div className={styles.Collapse}>
            <div className={styles.CollapseHeader}>
              <span className={styles.Title + "mb-0"}>Type</span>
            </div>
            <div className={styles.CheckboxesContainer}>
              {types_list.map((type_item, tdx) => {
                return (
                <Checkbox
                  checked={type === type_item.value}
                  className={styles.CheckboxStyle}
                onChange={(e) => {
                  checkbox_change(
                    type_item.value
                  );
                }}
                >
                  {type_item.label}
                </Checkbox>
                )
              })}
            </div>
            <div className={styles.Seprator} />
          </div> */}
          <Collapse
            className={styles.CollapseContainer}
            defaultActiveKey="types"
            expandIcon={({ isActive }) => (
              <BottomArrowIcon
                className="custom-icon-collapse"
                transform={`rotate(${isActive ? 180 : 0})`}
                width="10px"
                height="10px"
              />
            )}
          >
            <Collapse.Panel
              key={"types"}
              className={"credit-collapse-types"}
              header="Type"
            >
              <div className={styles.CheckboxesContainer}>
                {types_list.map((type_item, tdx) => {
                  return (
                    <Checkbox
                      checked={type === type_item.value}
                      className={styles.CheckboxStyle}
                      onChange={(e) => {
                        checkbox_change(type_item.value);
                      }}
                    >
                      {type_item.label}
                    </Checkbox>
                  );
                })}
              </div>
            </Collapse.Panel>
          </Collapse>
          {/* price */}
          <div className={styles.PriceContainer}>
            <label className={styles.Title}>Price</label>
            <div className={styles.InputsContainers}>
              <div className={`${styles.InputParent} ${styles.RightPadding}`}>
                <input
                  placeholder={"OMR 90"}
                  value={price_from}
                  onChange={(e) => set_price_from(e.target.value)}
                />
                <span className={styles.InputsLabel}>From</span>
              </div>
              <div className={`${styles.InputParent} ${styles.LeftPadding}`}>
                <input
                  placeholder={"OMR 10"}
                  value={price_to}
                  onChange={(e) => set_price_to(e.target.value)}
                />
                <span className={styles.InputsLabel}>To</span>
              </div>
            </div>
          </div>

          {/* Date container */}
          <div className={styles.PriceContainer}>
            <label className={styles.Title}>Date</label>
            <div className={styles.InputsContainers}>
              <div className={`${styles.InputParent} ${styles.RightPadding}`}>
                <DatePicker
                  value={date_from}
                  onChange={(value) => set_date_from(value)}
                  timePicker={false}
                  isGregorian={false}
                  inputJalaaliFormat="jYYYY-jMM-jDD"
                />
                <span className={styles.InputsLabel}>From</span>
                <div
                  onClick={() => set_date_from(null)}
                  className={styles.DateClear}
                >
                  <CancelIcon />
                </div>
              </div>

              <div className={`${styles.InputParent} ${styles.LeftPadding}`}>
                <DatePicker
                  value={date_to}
                  onChange={(value) => set_date_to(value)}
                  timePicker={false}
                  isGregorian={false}
                  inputJalaaliFormat="jYYYY-jMM-jDD"
                />
                <span className={styles.InputsLabel}>To</span>
                <div
                  onClick={() => set_date_to(null)}
                  className={styles.DateClear}
                >
                  <CancelIcon />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* submit button */}
        <div className={styles.SubmitContainer}>
          <Button
            style_width={"49%"}
            style_backgroundColor="type-error"
            style_color="#fff !important"
            style_fontSize="type-2"
            style_borderRadius="type-2"
            onClick={on_clear_filter}
            // className={styles.CancelButton}
          >
            Clear
          </Button>
          <Button
            style_width={"49%"}
            style_fontSize="type-2"
            style_color="#fff !important"
            style_borderRadius="type-2"
            onClick={() => {
              submit_filter(false);
              set_sidebar_open(false);
            }}
          >
            Filter
          </Button>
        </div>
      </div>

      {/* backdrop of sidebar */}
    </div>
  );
};

export default CreditFilterSidebar;
